import { Pressable, PressableProps, Text, View } from 'react-native'

import { cn } from '@/utils/cn'

interface RadioListItemProps extends PressableProps {
  hasBorderTop: boolean
  hasBorderBottom: boolean
  isChecked?: boolean
  label: string
}

export function RadioListItem({
  hasBorderTop,
  hasBorderBottom,
  isChecked = false,
  label,
  ...props
}: RadioListItemProps) {
  return (
    <Pressable {...props}>
      {({ pressed }) => (
        <View
          className={cn(
            'h-12 flex-row items-center justify-between border-border-10 bg-background-primary px-4',
            pressed && 'bg-background-secondary',
            hasBorderTop && 'border-t',
            hasBorderBottom && 'border-b'
          )}
        >
          <View className={'flex-row gap-3'}>
            <View
              className={cn(
                'size-6 rounded-xl',
                isChecked ? 'border-[5px] border-primary' : 'border border-text-tertiary'
              )}
            />
            <Text className={'text-base text-text-primary'}>{label}</Text>
          </View>
        </View>
      )}
    </Pressable>
  )
}
